<template>
  <div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <!-- Breadcrumb -->
      <app-breadcrumb>
        <template #contentright>

          <span class="text-nowrap" />

        </template>
      </app-breadcrumb>
      <b-row>
        <b-col md="12">
          <b-card aria-hidden="true">
            <!-- Alert: No item found -->
            <b-alert
              variant="danger"
              :show="errorMessage !== ''"
            >
              <h4 class="alert-heading">
                {{ errorMessage }}
              </h4>

            </b-alert>

            <!-- BODY -->
            <validation-observer
              #default="{ handleSubmit }"
              ref="refFormObserver"
            >
              <!-- Form -->
              <b-form
                class=""
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
              >
                <b-row>
                  <!-- Bên trái -->
                  <b-col>
                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8">
                        <!-- Name -->
                        <validation-provider
                          #default="validationContext"
                          :name="$t('Tên tiêu đề')"
                          rules="required"
                        >
                          <b-form-group>
                            <template #label>
                              <label class="d-block font-weight-bolder">Tên tiêu đề <span class="text-danger">*</span></label>
                            </template>
                            <b-form-input
                              id="name"
                              v-model="itemData.name"
                              :state="getValidationState(validationContext)"
                              trim
                            />

                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col md="4">

                        <validation-provider
                          #default="validationContext"
                          :name="$t('Thư mục')"
                          rules="required"
                        >
                          <b-form-group label-for="category_work_id">
                            <template #label>
                              <label class="d-block font-weight-bolder">Thư mục <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.folder_plan_id"
                              :options="dataFolderPlan"
                              :reduce="val => val.id"
                              label="name"
                              placeholder="--Chọn--"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-col>
                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8">
                        <!-- Mô tả -->
                        <b-form-group>
                          <template #label>
                            <label class="d-block font-weight-bolder">Nội dung </label>
                          </template>
                          <b-form-textarea
                            id="description"
                            v-model="itemData.content"
                            rows="4"
                          />
                        </b-form-group>
                        <b-form-group>
                          <template #label>
                            <label class="d-block font-weight-bolder">Ghi chú </label>
                          </template>
                          <b-form-textarea
                            id="note"
                            v-model="itemData.note"
                            rows="2"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">

                        <validation-provider
                          #default="validationContext"
                          :name="$t('Kênh phát sóng')"
                          rules="required"
                        >
                          <b-form-group label-for="manager_id">
                            <template #label>
                              <label class="d-block font-weight-bolder">Kênh phát sóng <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.channel_id"
                              :options="dataChannel"
                              :reduce="val => val.id"
                              label="name"
                              placeholder="--Chọn--"
                              @input="getNameOptionChannel($event)"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>

                        <validation-provider
                          #default="validationContext"
                          vid="begin_date"
                          name="Ngày bắt đầu"
                          rules="required"
                        >
                          <b-form-group
                            label="Ngày bắt đầu"
                            label-for="begin_date"
                          >
                            <template #label>
                              <label class="d-block font-weight-bolder pb-0">Ngày phát sóng<span class="text-danger">*</span></label>
                            </template>
                            <flat-pickr
                              v-model="itemData.broadcast_date"
                              class="form-control"
                              :config="configDate"
                              placeholder="dd-mm-yyyy"
                              theme="dark"
                              :state="getValidationState(validationContext)"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>

                        <validation-provider
                          #default="validationContext"
                          :name="$t('Chương trình')"
                          rules="required"
                        >
                          <b-form-group label-for="manager_id">
                            <template #label>
                              <label class="d-block font-weight-bolder">Chương trình <span class="text-danger">*</span></label>
                            </template>
                            <v-select
                              v-model="itemData.program_id"
                              :options="dataProgram"
                              :reduce="val => val.id"
                              label="name"
                              placeholder="--Chọn--"
                              @input="getNameOptionProgram($event)"
                            />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                    </b-col>

                    <b-col
                      md="12"
                      class="row"
                    >
                      <b-col md="8" />
                      <!-- File -->
                      <b-col cols="12">
                        <b-form-group>
                          <div class="attachedFiles">
                            <div class="fileupload">
                              <original-file
                                :attached-files="itemData.attached_files"
                                @update-attached-files="onUpdateAttachedFiles"
                              />
                            </div>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-col>
                  </b-col>

                </b-row>

                <!-- Form Actions -->
                <div class="d-flex mt-2">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2"
                    type="submit"
                  >
                    {{ $t('Save') }}
                  </b-button>
                </div>

              </b-form>
            </validation-observer>
          </b-card>

        </b-col>
      </b-row>
    </b-overlay>

  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BOverlay, BForm, BFormGroup, BButton, BFormInput, BFormInvalidFeedback,
  BFormTextarea,
} from 'bootstrap-vue'
import {
  ref, reactive, toRefs,
} from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import vSelect from 'vue-select'
import moment from 'moment'
import axios from 'axios';
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import {
  required, alphaNum, alphaNumDot, max, integer, positive,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import { getToken } from '@/auth/utils'
import {
  apiUpload, apiDownload,
} from '@/libs/initTinymce'

import axiosNews from '@/libs/axiosNews';
import OriginalFile from './OriginalFile.vue'

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BAlert,
    BOverlay,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
    BFormTextarea,
    OriginalFile,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
      positive,
      devices: [],
      itemDevice: [],
      studioId: integer,
      // items: [],
      forceUpdate: 0,

    }
  },
  watch: {
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(jpeg|jpe|jpg|gif|png|webp|mp3|mp4|wav|webm)$/i.test(newFile.name)) {
          this.$swal({
            title: '',
            html: '<b>Chỉ hỗ trợ định dạng:</b> jpg, png, jpeg, git, webp, mp3, wav, mp4, webm',
            allowOutsideClick: true,
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
          return prevent()
        }
      }
    },
    // inputFile(newFile, oldFile) {
    //   if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
    //     if (!this.$refs.upload.active) {
    //       this.$refs.upload.active = true
    //     }
    //   }

    //   if (newFile) {
    //     newFile.full_path = ''
    //     newFile.extension = newFile.name.split('.').pop().toLowerCase();
    //     if (['jpg', 'png', 'gif', 'jpeg', 'webp'].includes(newFile.extension)) {
    //       this.tabActive = 'image'
    //     } else if (['mp4', 'webm'].includes(newFile.extension)) {
    //       this.tabActive = 'video'
    //     } else {
    //       this.tabActive = 'audio'
    //     }
    //   }

    //   if (newFile && newFile.success) {
    //     if (newFile.response.code == 400) {
    //       newFile.error = 'Tải file thất bại'
    //     }
    //   }
    //   if (newFile && newFile.success) {
    //     if (newFile.response.code === 200) {
    //       newFile.fileId = newFile.response.data.id;
    //       newFile.full_path = newFile.response.data.full_path;
    //       newFile.extension = newFile.response.data.extension
    //       const result = newFile.response.data;
    //       const item = {
    //         id: result.id,
    //         extension: result.extension,
    //         size: newFile.size,
    //         uploaded: 1,
    //         file: result.file,
    //         name: result.name,
    //         uuid: result.uuid,
    //         mimetype: result.mimetype,
    //         full_path: result.full_path,
    //         type: result.type,
    //       }
    //       this.attachedFiles.push(item)
    //       console.log('this.attachedFiles-inputfile', this.attachedFiles);
    //     }
    //   }
    // },
    formatFileSize(bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      const k = 1024;
      const dm = decimals || 2;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    getExtention(file) {
      const fileExt = file.name.split('.').pop().toLowerCase();
      let cssClass = '';
      if (['docx', 'doc'].includes(fileExt)) {
        cssClass = 'icon_docx'
      } else if (['pdf'].includes(fileExt)) {
        cssClass = 'icon_pdf'
      } else if (['csv', 'xlsx', 'xls'].includes(fileExt)) {
        cssClass = 'icon_xls'
      } else if (['mp4', 'webm'].includes(fileExt)) {
        cssClass = 'icon_clip'
      } else if (['mp3', 'wav'].includes(fileExt)) {
        cssClass = 'icon_music'
      } else {
        cssClass = 'icon_img'
      }
      return cssClass;
    },
    inputFileAttach(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.uploadAttach.active) {
          this.$refs.uploadAttach.active = true
        }
      }
      if (newFile && newFile.error) {
        newFile.error = 'Tải lên thất bại'
      } else if (newFile && newFile.success && newFile.error == '') {
        if (newFile.response.code == 400) {
          newFile.error = 'Tải file thất bại'
        }
      }
      console.log('attachedFiles-123', this.attachedFiles);
      console.log('newFile', newFile);
      if (newFile && newFile.success) {
        if (newFile.response.code === 200) {
          newFile.fileId = newFile.response.data.id;
          newFile.full_path = newFile.response.data.full_path ?? newFile.response.data.file_local;
          newFile.extension = newFile.response.data.extension
          const result = newFile.response.data;
          console.log('result', result.uuid);
          const item = {
            id: result.id,
            extension: result.extension,
            size: newFile.size,
            uploaded: 1,
            file: result.file,
            name: result.name,
            uuid: result.uuid,
            mimetype: result.mimetype,
            full_path: result.full_path ?? result.file_local,
            type: result.type,
          }
          console.log('item', item);
          this.frmFiles.push(item)
          console.log('frmFiles', item);
        }
      }
    },
    onDeleteAttach(file) {
      if (this.attachedFiles.length > 0) {
        console.log('file', file);
        const attachedFiles = this.attachedFiles.filter((item) => item.id !== file.id)
        console.log('attachedFiles', attachedFiles);
        this.$refs.uploadAttach.remove(file);
        this.frmFiles = attachedFiles;

        // console.log(this.attachedFiles)
      }
    },
    downloadfile(item) {
      axios
        .get(item.full_path ?? item.file_local, {
          headers: {
            Accept: item.mimetype,
          },
          responseType: 'blob',
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: item.mimetype })
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = item.name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          console.log(JSON.stringify(error))
        })
    },

    getNameOptionProgram(value) {
      const rslt = this.dataProgram.find(o => o.id === value);
      if (rslt) {
        this.itemData.program_name = rslt.name
      }
    },
    getNameOptionChannel(value) {
      const rslt = this.dataChannel.find(o => o.id === value);
      if (rslt) {
        this.itemData.channel_name = rslt.name
      }
      if (value) {
        this.getProgram(value)
        // store.dispatch('registerPlan/findProgramByChannelId', { channelId: value })
        //   .then(response => {
        //     if (response.data.code === 200) {
        //       this.dataProgram = response.data.data;
        //     }
        //   })
      }
    },
    onUpdateAttachedFiles(file) {
      this.itemData.attached_files = file
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'devices-edit' ? 'add' : 'edit');
    // const loading = ref(!!id.value)
    const loading = ref(true)
    const errorMessage = ref('')
    const dataCategoryWork = ref([])
    const dataUser = ref([])
    const accessToken = getToken()
    const attachedFiles = ref([])
    const frmFiles = ref([])
    const dataFolderPlan = ref([])
    const dataChannel = ref([])
    const dataProgram = ref([])
    const custom_header = ref({
      Authorization: `Bearer ${accessToken}`,
    });
    const state = reactive({
      api_upload: apiUpload,
      api_download: apiDownload,
    })
    const statusOptions = [
      { name: 'Đang thực hiện', id: 10 },
      // { name: 'Duyệt', id: 20 },
      { name: 'Hoàn thành', id: 30 },
      { name: 'Từ chối', id: 40 },
    ];
    const priorityOptions = [
      { name: 'Cao', id: 10 },
      { name: 'Trung bình', id: 20 },
      { name: 'Bình thường', id: 30 },
      { name: 'Thấp', id: 40 },
    ];
    const defaultItemData = {
      name: '',
      content: '',
      status: 10,
      main_user_id: null,
      data_list_user_collaborators: [],
      note: '',
      finished_volume: 0,
      category_work_id: null,
      priority: 10,
      attached_files: [],
    }
    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetItemData)
    const formatDate = (value) => moment(String(value)).format('DD-MM-YYYY')

    const getProgram = (channelId) => {
      store.dispatch('registerPlan/findProgramByChannelId', { channelId })
        .then(response => {
          if (response.data.code === 200) {
            dataProgram.value = response.data.data;
            if (dataProgram.value.length === 0) {
              itemData.value.program_id = null
            }
          }
        })
    }
    const getAllChannel = () => {
      axiosNews
        .get('channel/list', {
        })
        .then((res) => {
          if (res) {
            dataChannel.value = res.data.data
          } else {
            // showToast('Lỗi tải file')
          }
        })
        .catch((e) => {
          // showToast('Lỗi tải file')
        })
    }
    getAllChannel();
    store.dispatch('registerPlan/fetchOne', { id: router.currentRoute.params.id })
      .then(response => {
        if (response.status === 200) {
          itemData.value = response.data.data
          frmFiles.value = itemData.value.data_files ? itemData.value.data_files : []
          attachedFiles.value = itemData.value.data_files ? itemData.value.data_files : []
          itemData.value.broadcast_date = formatDate(itemData.value.broadcast_date)
          itemData.value.attached_files = itemData.value.data_files ? itemData.value.data_files : []
          getProgram(itemData.value.channel_id)
          loading.value = false
        }
      })

    const onSubmit = () => {
      errorMessage.value = '';
      // loading.value = true;
      itemData.value.attachedFiles = frmFiles.value;
      store.dispatch('registerPlan/update', { data: itemData.value, id: itemData.value.id })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === 200) {
              showToast(response.data.message, { variant: 'success' });
              resetForm()
              // emit('updateData')
              router.push({ name: 'register-plan-list' })
            } else {
              showToast(response.data.message)
              errorMessage.value = response.data.message;
            }
          }
        })
    }
    const fetchFolder = () => {
      store.dispatch('registerPlan/fetchAllFolderPlan', {
        isPaginate: 0,
      })
        .then(response => {
          if (response.data.code === 200) {
            dataFolderPlan.value = response.data.data;
          }
        })
    }
    fetchFolder();

    const today = new Date();
    const hour = today.getHours();
    const minutes = today.getMinutes();
    const configDate = ref({
      dateFormat: 'd-m-Y',
      enableTime: false,
      locale: Vietnamese, // locale for this instance only
      defaultHour: hour,
      defaultMinute: minutes,
      time_24hr: true,
      theme: 'dark',
      minuteIncrement: 1,
    });

    return {
      ...toRefs(state),
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      // devices,
      refFormObserver,
      getValidationState,
      resetForm,
      resetItemData,
      onSubmit,
      // fetchData,
      dataUser,
      configDate,
      // convertCurrency,
      statusOptions,
      dataCategoryWork,
      priorityOptions,
      attachedFiles,
      frmFiles,
      custom_header,
      dataFolderPlan,
      dataProgram,
      dataChannel,
      getProgram,
    }
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-slider.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#group_finished_volume>div {
  display: flex;
}

#finished_volume {
  margin-right: 15px;
}
</style>
